import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';

const getDynamicStyles = (styles) => cssObj({});

const getStyles = (styles) => css(getDynamicStyles(styles), {});

export { getStyles };
